import PropTypes from 'prop-types';
import React from 'react';
import {PROJECTS_IN_PROGRESS_PAGE_COUNT} from "./donorProfileConstants.js";
import { ProjectCard } from '../common/ProjectCard.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';

export class ProjectsInProgress extends React.PureComponent {
	constructor(props, context) {
		super(props, context);
	}

	renderProjectCard(project){
		let donationDetails = this.props.projectsInProgressDonations.filter(d => d["projectId"] == project.id)[0]
		return (
				<div>
					<ProjectCard project={project} key={project.id} showGiveWidget={false} hideClassroomPhoto={false} />
					<div className="donation-date">
						Donated {donationDetails.donationDate} {donationDetails.anonymous ? "(only visible to you)" : ""}
					</div>
				</div>
		)
	}

	renderAllProjectCards(){
		return(
				<div>
					{this.props.projectsInProgress.map(p => this.renderProjectCard(p))}
					{this.props.loadingInProgressProjects && <LoadingEllipsis />}
				</div>

		);
	}

	renderShowMoreButton(){
		if(!this.props.loadingInProgressProjects && this.props.projectsInProgress.length % PROJECTS_IN_PROGRESS_PAGE_COUNT === 0 && !this.props.doantionsEndReached){
			return(
					<a className="button-secondary" onClick={this.props.showMoreProjectsInProgress}>Show more projects</a>
			)
		}
	}

	render() {
		let multipleProjectsInProgress = this.props.projectsInProgressDonations.length > 1;
		return (
				<section className="projects-in-progress">
					<h2>{this.props.viewingOwnPage ? "You" : this.props.displayName} helped {multipleProjectsInProgress ? "these projects" : "this project"}-in-progress</h2>
					<div className='project-card-section'>
						{this.renderAllProjectCards()}
					</div>
					{this.renderShowMoreButton()}
				</section>
		);
	}
}

ProjectsInProgress.propTypes = {
	displayName: PropTypes.string.isRequired,
	projectsInProgress: PropTypes.array,
	projectsInProgressDonations: PropTypes.array.isRequired,
	viewingOwnPage: PropTypes.bool.isRequired,
	loadingInProgressProjects: PropTypes.bool,
	showMoreProjectsInProgress: PropTypes.func.isRequired,
	doantionsEndReached: PropTypes.bool
};
